module.exports = __webpack_public_path__ + "static/215aa9ecc015a103c853e8f9cf69dab6cec9a4ec2aac05ca698bee44fe284810-b5336e2fa34345f74d21b4ecf6d32713.png";